/**
 * @title Api Documentation
 * @description Api Documentation
 * @version 1.0
 *
 * Swagger version 2.0
 * Generated at: Thu Sep 09 2021 10:51:26 GMT+0200 (czas środkowoeuropejski letni)
 */

import { API_URLS } from '../utils/config';
import { request } from '../utils/request';
import prepareQueryParams from 'utils/prepareQueryParams';

const URL = API_URLS.PRICING;

export interface AbstractResponse<D, L> {
  code: string;
  data: D;
  description: string;
  list: Array<L>;
  message: string;
}

export interface ParCommission {
  commbasis: string;
  commcalculationmethod: string;
  commcode: string;
  commduration: string;
  commdurationdefault: number;
  commfixedamount: number;
  commlabel: string;
  commpercentage: number;
  commperiodicity: string;
  commrepaymode: string;
  commstatus: string;
  commtype: string;
  enddate: string;
  startdate: string;
  taxcode: string;
  tpid: number;
  tprole: string;
}

export interface ParCommissionCriteria {
  commcode: string;
  criid: number;
  critcode: string;
  critvalue: string;
  critvaluemax: string;
  critoperand: string;
  commvalue: number;
  listvalue: string;
}

export interface ParCommissionCriteriaResponse {
  commcode: string;
  criid: number;
  critcode: string;
  critcodelabel: string;
  critvalue: string;
  critvaluelabel: string;
  critvaluemax: string;
  critoperand: string;
  commvalue: number;
  listvalue: string;
}

export interface ParCommissionResponse {
  commbasis: string;
  commbasislabel: string;
  commcalculationmethod: string;
  commcalculationmethodlabel: string;
  commcode: string;
  commduration: string;
  commdurationdefault: number;
  commdurationlabel: string;
  commfixedamount: number;
  commlabel: string;
  commpercentage: number;
  commperiodicity: string;
  commperiodicitylabel: string;
  commrepaymode: string;
  commrepaymodelabel: string;
  commstatus: string;
  commstatuslabel: string;
  commtype: string;
  commtypelabel: string;
  enddate: string;
  startdate: string;
  taxcode: string;
  taxrate: number;
  taxtype: string;
  tpid: number;
  tpname: string;
  tprole: string;
  tprolelabel: string;
  currcode: string;
}

export interface ParList {
  id: number;
  lancode: string;
  mgid: number;
  parcode: string;
  parflagdefault: boolean;
  parlistlabel: string;
  parmodule: string;
  parvalue: string;
  parvalueparent: string;
}

export interface GetMgListByOfferidParams {
  offerid: number;
}

export function getMgListByOfferid(params: GetMgListByOfferidParams) {
  return request.get<AbstractResponse<object, MGCompanyList>>(
    `${URL}/api/mgoffer/${params.offerid}`
  );
}

export interface MGCompanyList {
  mgid: number;
  mgname: string;
  mgreference: string;
}

export interface ParOfferPricingAttributeResponse {
  attlabel: string;
  attid: number;
  offerid: number;
  priid: number;
  atttype: string;
  atttypelabel: string;
  tpid: number;
  tpname: string;
  tpreference: string;
  tprole: string;
  attcode: string;
  attcodelabel: string;
  attdirection: string;
  attmethod: string;
  attmethodlabel: string;
  attexternalreference: string;
  attamountmethod: string;
  attamountmethodlabel: string;
  attamountmin: number;
  attamountdefault: number;
  attamountmax: number;
  attcoefmin: number;
  attcoefdefault: number;
  attcoefmax: number;
  attrate: number;
  attnbdays: number;
  flagaddmanual: boolean;
  flagupdate: boolean;
  flagdelete: boolean;
  flagstrictcheck: boolean;
  requesttype: string;
  requestreceivertype: string;
  requestreceiverroleprofile: string;
  requestreceiverid: number;
  proccode: string;
  proclabel: string;
  taskid: number;
  tasklabel: string;
  nbmonthsmax: number;
  flagaddauto: boolean;
  startdate: string;
  enddate: string;
  status: string;
  attbudget: number;
  attbudgetbooked: number;
  attbudgetused: number;
  statuslabel: string;

  proccodefollowup: string;
  taskidfollowup: number;
  valuetofollowup: string;
  targetvaluetofollowup: number;

  proccodefollowuplabel: string;
  taskidfollowuplabel: string;
  valuetofollowuplabel: string;
  attcomment: string;

  attamountrequested: number;
  attamountagreed: number;
  nbmonthsrequested: number;
}

export interface PricingApplicationRule {
  check: boolean;
  rulelabel: string;
  rulevalue: string;
}
export interface MUserJobAuthorizationCheck {
  check: boolean;
  applicationRules: Array<PricingApplicationRule>;
}

export interface MUserJobAuthorizationCheckResponse {
  check: boolean;
  attribute: string;
  attributevalue: string;
  applicationRules: Array<MUserJobAuthorizationCheck>;
}

export interface parOfferPrefinStep {
  ctesid: number;
  offerid: number;
  ctesorder: number;
  ctesduration: number;
  ctesperiodicityunit: string;
  ctesperiodicity: string;
  calmethod: string;
  rateformula: string;
  ratebasis: string;
  ratespread: number;
  nominalrate: number;
  ctesamortizedcoef: number;
  ctesamortizedamount: number;
  ctesoutstandingcoef: number;
  ctesoutstandingamount: number;
  ctesstartdate?: string;
  ctesenddate?: string;
}

export interface ParOfferResponse {
  pricingChecklist: Array<MUserJobAuthorizationCheckResponse>;
  priidexeed: number;
  priidexeedlabel: string;
  priidexeedtaskid: number;
  attributeList: Array<ParOfferPricingAttributeResponse>;
  servicesList: Array<PricingResponse>;
  depositratetype: string;
  deferredinterestratetype: string;
  taxtype: string;
  calculationbasis: string;
  ctflagreminder: boolean;
  ctinvoicesendingmode: string;
  calculationmethod: string;
  ctinvoicingmode: string;
  ctlateinterestformula: string;
  ctpartialpayoffformula: string;
  ctpaymentdelay: number;
  cttotalpayoffformula: string;
  cttype: string;
  ctvaliditydelay: number;
  deferredinterestmethod: string;
  deferredinterestnominalrate: number;
  depositamount: number;
  depositcoef: number;
  depositinterestmethod: string;
  depositnominalrate: number;
  durationdefault: number;
  durationmax: number;
  durationmin: number;
  durationreqreceiverid: number;
  durationreqreceiverroleprofile: string;
  durationreqreceivertype: string;
  durationreqtype: string;
  enddate: string;
  finamountmax: number;
  finamountmin: number;
  firstrentaldefault: number;
  firstrentalmax: number;
  firstrentalmin: number;
  firstrentalreqreceiverid: number;
  firstrentalreqreceiverroleprofile: string;
  firstrentalreqreceivertype: string;
  firstrentalreqtype: string;
  gpduration: number;
  gpmethod: string;
  interestmethod: string;
  mgid: number;
  offerid: number;
  offerlabel: string;
  offerstatus: string;
  partamount: number;
  partmethod: string;
  partnbdays: number;
  partnbdaysmax: number;
  partrate: number;
  periodicity: string;
  prcode: string;
  prefinbasis: string;
  prefinmethod: string;
  prefinnominalrate: number;
  prefinperiodicity: string;
  prefinrateformula: string;
  prefinratetype: string;
  prefinratespreaddefault: number;
  prefinratespreadmax: number;
  prefinratespreadmin: number;
  prefinrateref: number;
  rateformula: string;
  rateperiodicity: number;
  ratereqreceiverid: number;
  ratereqreceiverroleprofile: string;
  ratereqreceivertype: string;
  ratereqtype: string;
  ratespreaddefault: number;
  ratespreadmax: number;
  ratespreadmin: number;
  ratetype: string;
  ratevaluedefault: number;
  rvdefault: number;
  rvdefaultamount: number;
  rvmax: number;
  rvmin: number;
  rvreqreceiverid: number;
  rvreqreceiverroleprofile: string;
  rvreqreceivertype: string;
  rvreqtype: string;
  rvevaluationmode: string;
  rvcalculationmode: string;
  startdate: string;
  taxcode: string;
  currcode: string;
  term: string;
  tpidparticipation: number;
  tpnameparticipation: string;
  tpreferenceparticipation: string;
  tprole: string;
  unit: string;
  upfrontdefault: number;
  upfrontmax: number;
  upfrontmin: number;
  upfrontreqreceiverid: number;
  upfrontreqreceiverroleprofile: string;
  upfrontreqreceivertype: string;
  upfrontreqtype: string;
  ctebilligdate: string;
  taxrate: number;
  spvassetdiscount: number;
  spvriskrate: number;
  spvadditionalfees: number;
  spvloancoef: number;
  spvdiscountsale: number;
  spvinflation: number;

  rvcontextmax: number;
  rvcontextmin: number;
  servauthid: number;
  servtaskid: number;

  rvauthid: number;
  rvtaskid: number;
  ratecontextmax: number;
  ratecontextmin: number;
  rateauthid: number;
  ratetaskid: number;
  frcontextmax: number;
  frcontextmin: number;
  frauthid: number;
  frtaskid: number;
  durationcontextmax: number;
  durationcontextmin: number;
  durationauthid: number;
  durationtaskid: number;
  marginratemin: number;
  marginratemax: number;
  margincontextmin: number;
  margincontextmax: number;
  margintaskid: number;
  marginauthid: number;
  gpmin: number;
  gpmax: number;
  prefinStepList?: Array<parOfferPrefinStep>;
  ceilingrate: number;
  ceilingdefaultrate: number;
  floorrate: number;
  floordefaultrate: number;
  calid: number;

  partratetype: string;
  partrateformula: string;
  partinvoicingmode: string;

  partratespread: number;
}

export interface ParOffer {
  rvcontextmax: number;
  rvcontextmin: number;
  frcontextmax: number;
  frcontextmin: number;
  deferredinterestratetype: string;
  depositratetype: string;

  durationcontextmax: number;
  durationcontextmin: number;
  ratecontextmax: number;
  ratecontextmin: number;

  calculationbasis: string;

  calculationmethod: string;
  deferredinterestmethod: string;
  deferredinterestnominalrate: number;
  depositamount: number;
  depositcoef: number;
  depositinterestmethod: string;
  depositnominalrate: number;
  durationdefault: number;
  durationmax: number;
  durationmin: number;
  durationreqreceiverid: number;
  durationreqreceiverroleprofile: string;
  durationreqreceivertype: string;
  durationreqtype: string;
  enddate: string;
  finamountmax: number;
  finamountmin: number;
  firstrentaldefault: number;
  firstrentalmax: number;
  firstrentalmin: number;
  firstrentalreqreceiverid: number;
  firstrentalreqreceiverroleprofile: string;
  firstrentalreqreceivertype: string;
  firstrentalreqtype: string;
  gpduration: number;
  gpmethod: string;
  interestmethod: string;
  mgid: number;
  offerid: number;
  offerlabel: string;
  offerstatus: string;
  partamount: number;
  partmethod: string;
  partnbdays: number;
  partnbdaysmax: number;
  partrate: number;
  periodicity: string;
  prcode: string;
  prefinbasis: string;
  prefinmethod: string;
  prefinnominalrate: number;
  prefinperiodicity: string;
  prefinrateformula: string;
  prefinratetype: string;
  prefinratespreaddefault: number;
  prefinratespreadmax: number;
  prefinratespreadmin: number;
  prefinrateref: number;

  rateformula: string;
  rateperiodicity: number;
  ratereqreceiverid: number;
  ratereqreceiverroleprofile: string;
  ratereqreceivertype: string;
  ratereqtype: string;
  ratespreaddefault: number;
  ratespreadmax: number;
  ratespreadmin: number;
  ratetype: string;
  ratevaluedefault: number;
  rvdefault: number;
  rvdefaultamount: number;
  rvmax: number;
  rvmin: number;

  gpmax: number;
  gpmin: number;
  rvreqreceiverid: number;
  rvreqreceiverroleprofile: string;
  rvreqreceivertype: string;
  rvreqtype: string;
  rvevaluationmode: string;
  rvcalculationmode: string;
  startdate: string;
  taxcode: string;
  currcode: string;
  term: string;
  tpidparticipation: number;
  tprole: string;
  unit: string;
  upfrontdefault: number;
  upfrontmax: number;
  upfrontmin: number;
  upfrontreqreceiverid: number;
  upfrontreqreceiverroleprofile: string;
  upfrontreqreceivertype: string;
  upfrontreqtype: string;
  ctebilligdate: string;
  taxrate: number;
  spvassetdiscount: number;
  spvriskrate: number;
  spvadditionalfees: number;
  spvloancoef: number;
  spvdiscountsale: number;
  spvinflation: number;
}

export interface ParPricing {
  additionalcostaftermargin: number;
  allowfinservice: boolean;
  calculatedamountbasis: string;
  calculationbasis: string;
  calculationmethod: string;
  cilcategory: string;
  ciltype: string;
  citype: string;
  ctecategory: string;
  ctetype: string;
  deferredinterestmethod: string;
  deferredinterestnominalrate: number;
  depositamount: number;
  depositcoef: number;
  depositinterestmethod: string;
  depositnominalrate: number;
  durationdefault: number;
  durationmax: number;
  durationmin: number;
  durationreqreceiverid: number;
  durationreqreceiverroleprofile: string;
  durationreqreceivertype: string;
  durationreqtype: string;
  enddate: string;
  finamountmax: number;
  finamountmin: number;
  firstrentaldefault: number;
  firstrentalmax: number;
  firstrentalmin: number;
  firstrentalreqreceiverid: number;
  firstrentalreqreceiverroleprofile: string;
  firstrentalreqreceivertype: string;
  firstrentalreqtype: string;
  flagfollowgraceperiod: boolean;
  flagmandatory: boolean;
  flagupdate: boolean;
  gpduration: number;
  gpmethod: string;
  interestmethod: string;
  marginoncalulatedcamount: number;
  partamount: number;
  partmethod: string;
  partnbdays: number;

  partrate: number;
  periodicity: string;
  prefinbasis: string;
  prefinmethod: string;
  prefinnominalrate: number;
  prefinperiodicity: string;
  prefinrateformula: string;
  prefinratetype: string;
  pridescription: string;
  priid: number;
  prilabel: string;
  pristatus: string;
  rateformula: string;
  rateperiodicity: number;
  ratereqreceiverid: number;
  ratereqreceiverroleprofile: string;
  ratereqreceivertype: string;
  ratereqtype: string;
  ratespreaddefault: number;
  ratespreadmax: number;
  ratespreadmin: number;
  ratetype: string;
  ratevaluedefault: number;
  rvdefault: number;
  rvdefaultamount: number;
  rvmax: number;
  rvmin: number;
  rvreqreceiverid: number;
  rvreqreceiverroleprofile: string;
  rvreqreceivertype: string;
  rvreqtype: string;
  rvevaluationmode: string;
  rvcalculationmode: string;
  servcalculationmethod: string;
  servfixedamount: number;
  servfixedamountmin: number;
  serviceduration: string;
  servpercentage: number;
  servpercentagemin: number;
  servreqreceiverid: number;
  servreqreceiverroleprofile: string;
  servreqreceivertype: string;
  servreqtype: string;
  startdate: string;
  taxcode: string;
  term: string;
  tpidparticipation: number;
  tprole: string;
  unit: string;
  upfrontdefault: number;
  upfrontmax: number;
  upfrontmin: number;
  upfrontreqreceiverid: number;
  upfrontreqreceiverroleprofile: string;
  upfrontreqreceivertype: string;
  upfrontreqtype: string;
  spvassetdiscount: number;
  spvriskrate: number;
  spvadditionalfees: number;
  spvloancoef: number;
  spvdiscountsale: number;
  spvinflation: number;
}

export interface ParPricingCommCriteria {
  criid: number;
  critcode: string;
  critvalue: string;
  critvaluemax: string;
  critoperand: string;
  listvalue: string;
  commvalue: number;
  pricommid: number;
}

export interface ParPricingCommCriteriaResponse {
  criid: number;
  critcode: string;
  critcodelabel: string;
  critvalue: string;
  critvaluelabel: string;
  critvaluemax: string;
  critoperand: string;
  listvalue: string;
  commvalue: number;
  pricommid: number;
}

export interface ParPricingCommission {
  commbasis: string;
  commcode: string;
  commfixedamount: number;
  commlabel: string;
  commpercentage: number;
  commstatus: string;
  commtype: string;
  enddate: string;
  finamountmax: number;
  finamountmin: number;
  finratemax: number;
  finratemin: number;
  prcommid: number;
  priid: number;
  startdate: string;
  tpid: number;
  tprole: string;
}

export interface ParPricingCommissionResponse {
  commbasis: string;
  commbasislabel: string;
  commcode: string;
  commfixedamount: number;
  commlabel: string;
  commpercentage: number;
  commstatus: string;
  commstatuslabel: string;
  commtype: string;
  commtypelabel: string;
  enddate: string;
  finamountmax: number;
  finamountmin: number;
  finratemax: number;
  finratemin: number;
  prcommid: number;
  priid: number;
  startdate: string;
  tpid: number;
  tpname: string;
  tprole: string;
  tprolelabel: string;
}

export interface ParPricingCriteria {
  criid: number;
  critcode: string;
  critvalue: string;
  critvaluemax: string;
  critoperand: string;
  listvalue: string;
  priid: number;
}

export interface ParPricingCriteriaResponse {
  criid: number;
  critcode: string;
  critcodelabel: string;
  critvalue: string;
  critvaluelabel: string;
  critvaluemax: string;
  critoperand: string;
  listvalue: string;
  priid: number;
  applicationrule: string;
}

export interface ParPricingListResponse {
  calculationbasis: string;
  calculationbasislabel: string;
  calculationmethod: string;
  calculationmethodlabel: string;
  ctecategory: string;
  ctecategorylabel: string;
  ctetype: string;
  ctetypelabel: string;
  durationmax: number;
  durationmin: number;
  enddate: string;
  finamountmax: number;
  finamountmin: number;
  pridescription: string;
  priid: number;
  prilabel: string;
  pristatus: string;
  startdate: string;
  statuslabel: string;
}

export interface ParPricingPack {
  enddate: string;
  packdescription: string;
  packid: number;
  packlabel: string;
  packstatus: string;
  startdate: string;
}

export interface ParPricingPackCriteria {
  criid: number;
  critcode: string;
  critvalue: string;
  critvaluemax: string;
  critoperand: string;
  listvalue: string;
  packid: number;
  applicationrule: string;
}

export interface ParPricingPackCriteriaResponse {
  criid: number;
  critcode: string;
  critcodelabel: string;
  critvalue: string;
  critvaluelabel: string;
  critvaluemax: string;
  critoperand: string;
  listvalue: string;
  packid: number;
  applicationrule: string;
}

export interface ParPricingPackDetail {
  enddate: string;
  flagmandatory: boolean;
  flagupdate: boolean;
  packid: number;
  packpriid: number;
  priid: number;
  startdate: string;
}

export interface ParPricingPackDetailResponse {
  ctecategory: string;
  ctecategorylabel: string;
  ctetype: string;
  ctetypelabel: string;
  enddate: string;
  flagmandatory: boolean;
  flagupdate: boolean;
  packid: number;
  packpriid: number;
  priid: number;
  prilabel: string;
  startdate: string;
}

export interface ParPricingPackResponse {
  enddate: string;
  packdescription: string;
  packid: number;
  packlabel: string;
  packstatus: string;
  packstatuslabel: string;
  startdate: string;
}

export interface ParPricingResponse {
  additionalcostaftermargin: number;
  allowfinservice: boolean;
  calculatedamountbasis: string;
  calculatedamountbasislabel: string;
  calculationbasis: string;
  calculationmethod: string;
  cilcategory: string;
  cilcategorylabel: string;
  ciltype: string;
  ciltypelabel: string;
  citype: string;
  citypelabel: string;
  ctecategory: string;
  ctecategorylabel: string;
  ctetype: string;
  ctetypelabel: string;
  deferredinterestmethod: string;
  deferredinterestnominalrate: number;
  depositamount: number;
  depositcoef: number;
  depositinterestmethod: string;
  depositnominalrate: number;
  durationdefault: number;
  durationmax: number;
  durationmin: number;
  durationreqreceiverid: number;
  durationreqreceiverroleprofile: string;
  durationreqreceivertype: string;
  durationreqtype: string;
  enddate: string;
  finamountmax: number;
  finamountmin: number;
  firstrentaldefault: number;
  firstrentalmax: number;
  firstrentalmin: number;
  firstrentalreqreceiverid: number;
  firstrentalreqreceiverroleprofile: string;
  firstrentalreqreceivertype: string;
  firstrentalreqtype: string;
  flagfollowgraceperiod: boolean;
  flagmandatory: boolean;
  flagupdate: boolean;
  gpduration: number;
  gpmethod: string;
  interestmethod: string;
  marginoncalulatedcamount: number;
  partamount: number;
  partmethod: string;
  partnbdays: number;
  partrate: number;
  periodicity: string;
  prefinbasis: string;
  prefinmethod: string;
  prefinnominalrate: number;
  prefinperiodicity: string;
  prefinrateformula: string;
  prefinratetype: string;
  pridescription: string;
  priid: number;
  prilabel: string;
  pristatus: string;
  rateformula: string;
  rateperiodicity: number;
  ratereqreceiverid: number;
  ratereqreceiverroleprofile: string;
  ratereqreceivertype: string;
  ratereqtype: string;
  ratespreaddefault: number;
  ratespreadmax: number;
  ratespreadmin: number;
  ratetype: string;
  ratevaluedefault: number;
  rvdefault: number;
  rvdefaultamount: number;
  rvmax: number;
  rvmin: number;
  rvreqreceiverid: number;
  rvreqreceiverroleprofile: string;
  rvreqreceivertype: string;
  rvreqtype: string;
  rvevaluationmode: string;
  rvcalculationmode: string;
  servcalculationmethod: string;
  servfixedamount: number;
  servfixedamountmin: number;
  serviceduration: string;
  servpercentage: number;
  servpercentagemin: number;
  servreqreceiverid: number;
  servreqreceiverroleprofile: string;
  servreqreceivertype: string;
  servreqtype: string;
  startdate: string;
  statuslabel: string;
  taxcode: string;
  term: string;
  tpidparticipation: number;
  tprole: string;
  unit: string;
  upfrontdefault: number;
  upfrontmax: number;
  upfrontmin: number;
  upfrontreqreceiverid: number;
  upfrontreqreceiverroleprofile: string;
  upfrontreqreceivertype: string;
  upfrontreqtype: string;
  spvassetdiscount: number;
  spvriskrate: number;
  spvadditionalfees: number;
  spvloancoef: number;
  spvdiscountsale: number;
  spvinflation: number;
}

export interface ParPricingStep {
  ctesamortizedcoef: number;
  ctesduration: number;
  ctesid: number;
  ctesorder: number;
  ctesoutstandingamount: number;
  ctesperiodicity: string;
  ctesrentalamount: number;
  ctesrentalcoef: number;
  ctesperiodicityunit: string;
  priid: number;
}

export interface ParService {
  additionalcostaftermargin: number;
  calculatedamountbasis: string;
  cilcategory: string;
  ciltype: string;
  citype: string;
  enddate: string;
  flagautoexpense: boolean;
  marginoncalulatedcamount: number;
  servbasis: string;
  servcalculationmethod: string;
  servcategory: string;
  servcode: string;
  servduration: string;
  servdurationdefault: number;
  servfixedamount: number;
  servlabel: string;
  servpercentage: number;
  servperiodicity: string;
  servrepayfixedamount: number;
  servrepaymode: string;
  servrepaypercentage: number;
  servstatus: string;
  servtype: string;
  startdate: string;
  taxcode: string;
  tpidsupplier: number;
  tprole: string;
  servrepaybasis: string;
  servrepayduration: string;
  rateformula: string;
  servfreebasisdefault: number;
  ratetype: string;
  servuseunit: string;
  servusefrequency: string;
  servuseqty: number;
  servuseminamount: number;
  servusemaxamount: number;
  servusecoverage: number;
  servusedeductionamount: number;
  servusedeductionpercenrage: number;
  servdescription: string;
}

export interface ParServiceCriteria {
  criid: number;
  critcode: string;
  critvalue: string;
  servcode: string;
  critvaluemax: string;
  critoperand: string;
  servvalue: number;
  listvalue: string;
  applicationrule: string;
}

export interface ParServiceCriteriaResponse {
  criid: number;
  critcode: string;
  critcodelabel: string;
  critvalue: string;
  critvaluelabel: string;
  servcode: string;
  critvaluemax: string;
  critoperand: string;
  listvalue: string;
  servvalue: number;
  applicationrule: string;
}

export interface ParServiceResponse {
  additionalcostaftermargin: number;
  calculatedamountbasis: string;
  calculatedamountbasislabel: string;
  cilcategory: string;
  cilcategorylabel: string;
  ciltype: string;
  ciltypelabel: string;
  citype: string;
  citypelabel: string;
  enddate: string;
  flagautoexpense: boolean;
  marginoncalulatedamount: number;
  servbasis: string;
  servbasislabel: string;
  servcalculationmethod: string;
  servcalculationmethodlabel: string;
  servcategory: string;
  servcategorylabel: string;
  servcode: string;
  servduration: string;
  servdurationdefault: number;
  servdurationlabel: string;
  servfixedamount: number;
  servlabel: string;
  servpercentage: number;
  servperiodicity: string;
  servperiodicitylabel: string;
  servrepayfixedamount: number;
  servrepaymode: string;
  servrepaymodelabel: string;
  servrepaypercentage: number;
  servstatus: string;
  servstatuslabel: string;
  servtype: string;
  servtypelabel: string;
  startdate: string;
  taxcode: string;
  tpidsupplier: number;
  tpname: string;
  tpreference: string;
  tprole: string;
  servrepaybasis: string;
  servrepaybasislabel: string;
  servrepayduration: string;
  servrepaydurationlabel: string;
  servfreebasisdefault: number;
  ratetype: string;
  rateformula: string;
  servuseunit: string;
  servusefrequency: string;
  servuseqty: number;
  servuseminamount: number;
  servusemaxamount: number;
  servusecoverage: number;
  servusedeductionamount: number;
  servusedeductionpercenrage: number;
  servdescription: string;
}

export interface ParServiceStep {
  ctesid: number;
  assetcategory: string;
  assettype: string;
  deprpercentage: number;
  servamount: number;
  servcode: string;
  servpercentage: number;
  stepduration: number;
  stepid: number;
  steporder: number;
  stepunit: string;
}

export interface PricingPackResponse {
  ofrdescription: string;
  ofrid: number;
  ofrlabel: string;
  ofrtype: string;
}

export interface PricingResponse {
  ctebilligdate: string;
  allowfinservice: boolean;
  calculationbasis: string;
  calculationmethod: string;
  depositratetype: string;
  deferredinterestratetype: string;
  commissionList: Array<ParCommissionResponse>;
  attributeList: Array<ParOfferPricingAttributeResponse>;
  marginratemin: number;
  marginratemax: number;
  margincontextmin: number;
  margincontextmax: number;
  ctecategory: string;
  ctetype: string;
  deferredinterestmethod: string;
  deferredinterestnominalrate: number;
  depositamount: number;
  depositcoef: number;
  depositinterestmethod: string;
  depositnominalrate: number;
  durationdefault: number;
  durationmax: number;
  durationmin: number;
  durationreqreceiverid: number;
  durationreqreceiverroleprofile: string;
  durationreqreceivertype: string;
  durationreqtype: string;
  enddate: string;
  finamountmax: number;
  finamountmin: number;
  firstrentaldefault: number;
  firstrentalmax: number;
  firstrentalmin: number;

  firstrentalreqreceiverid: number;
  firstrentalreqreceiverroleprofile: string;
  firstrentalreqreceivertype: string;
  firstrentalreqtype: string;
  flagfollowgraceperiod: boolean;
  flagmandatory: boolean;
  flagupdate: boolean;
  gpduration: number;
  gpmethod: string;
  interestmethod: string;
  partamount: number;
  partmethod: string;
  partnbdays: number;
  partrate: number;
  periodicity: string;
  prefinbasis: string;
  prefinmethod: string;
  prefinnominalrate: number;
  prefinperiodicity: string;
  prefinrateformula: string;
  prefinratetype: string;
  pricingStepList: Array<ParPricingStep>;
  pridescription: string;
  priid: number;
  prilabel: string;
  pristatus: string;
  rateformula: string;
  rateperiodicity: number;
  ratereqreceiverid: number;
  ratereqreceiverroleprofile: string;
  ratereqreceivertype: string;
  ratereqtype: string;
  ratespreaddefault: number;
  ratespreadmax: number;
  ratespreadmin: number;

  ratetype: string;
  ratevaluedefault: number;
  rvdefault: number;
  rvevaluationmode: string;
  rvdefaultamount: number;
  rvmax: number;
  rvmin: number;
  gpmax: number;
  gpmin: number;
  rvcontextmax: number;
  rvcontextmin: number;
  rvreqreceiverid: number;
  rvreqreceiverroleprofile: string;
  rvcalculationmode: string;
  rvreqreceivertype: string;
  rvreqtype: string;
  servcalculationmethod: string;
  servfixedamount: number;
  servfixedamountmin: number;
  servcontextmin: number;
  serviceResponse: ParServiceResponse;
  commissionResponse: ParCommissionResponse;
  serviceStepList: Array<ParServiceStep>;
  serviceduration: string;
  servpercentage: number;
  servpercentagemin: number;
  servreqreceiverid: number;
  servreqreceiverroleprofile: string;
  servreqreceivertype: string;
  servreqtype: string;
  startdate: string;
  taxcode: string;
  taxrate: number;
  taxtype: string;
  term: string;
  tpidparticipation: number;
  tprole: string;
  unit: string;
  upfrontdefault: number;
  upfrontmax: number;
  upfrontmin: number;
  upfrontreqreceiverid: number;
  upfrontreqreceiverroleprofile: string;
  upfrontreqreceivertype: string;
  upfrontreqtype: string;
  spvassetdiscount: number;
  spvriskrate: number;
  spvadditionalfees: number;
  spvloancoef: number;
  spvdiscountsale: number;
  spvinflation: number;
  rvauthid: number;
  rvtaskid: number;
  servauthid: number;
  servtaskid: number;
  marginauthid: number;
  margintaskid: number;
  ratecontextmax: number;
  ratecontextmin: number;
  rateauthid: number;
  ratetaskid: number;
  frcontextmax: number;
  frcontextmin: number;
  frauthid: number;
  frtaskid: number;
  durationcontextmax: number;
  durationcontextmin: number;
  durationauthid: number;
  durationtaskid: number;

  partratetype: string;
  partrateformula: string;
  partinvoicingmode: string;
  servusecoverage: any;
  servusedeductionamount: number;
  servusedeductionpercenrage: number;
  servusefrequency: string;
  servusemaxamount: number;
  servuseminamount: number;
  servuseqty: number;
  servuseunit: string;
}

export interface GetPricingListParams {
  ctetype: string;
  flagdefault: boolean;
  mgid: number;
  priid: number;
  prilabel: string;
}

export interface GetPricingListFilteredParams {
  entity: string;
  entityid: number;
  offerid: number;
  ctetype: string;
  prcode: string;
  tpid: number;
  filtersPricing?: string;
  filtersValue?: string;
}

export interface ViewPricingList {
  ctetype: string;
  flagdefault: boolean;
  id: number;
  mgid: number;
  priid: number;
  prilabel: string;
  filterid: number;
}

export interface MgUserJobAuthorizationRequest {
  applicationrule: string;
  attcode: string;
  attlabel: string;
  authid: number;
  authtype: string;
  critcode: string;
  critoperand: string;
  valueoperand: string;
  critvalue: string;
  critvaluemax: string;
  listvalue: string;
  mgid: number;
  mgname: string;
  offerid: number;
  offerlabel: string;
  prcode: string;
  priid: number;
  prilabel: string;
  proccode: string;
  proclabel: string;
  productlabel: string;
  rangemax: number;
  rangemin: number;
  taskid: number;
  tasklabel: string;
  userjob: string;
  userjoblabel: string;
  valuedefault: number;
  valuemax: number;
  valuemin: number;
  tpid: number;
  tprole: string;
  userid: number;
  tpreference: string;
  tpname: string;
  username: string;
  rvid?: number;
}

export interface MgUserJobAuthorizationResponse {
  applicationrule: string;
  applicationruleexclude: string;
  attcode: string;
  attlabel: string;
  authid: number;
  authtype: string;
  critcode: string;
  critoperand: string;
  valueoperand: string;
  critvalue: string;
  critvaluemax: string;
  listvalue: string;
  mgid: number;
  mgname: string;
  offerid: number;
  offerlabel: string;
  prcode: string;
  priid: number;
  prilabel: string;
  proccode: string;
  proclabel: string;
  productlabel: string;
  rangemax: number;
  rangemin: number;
  taskid: number;
  tasklabel: string;
  userjob: string;
  userjoblabel: string;
  valuedefault: number;
  valuemax: number;
  valuemin: number;
  tpid: number;
  tprole: string;
  userid: number;
  tpreference: string;
  tpname: string;
  username: string;
  filterid?: number;
}
/**
 * @tags Pricing Controller
 * @summary getPricingList
 */

export function getPricingListFiltered(params: GetPricingListFilteredParams) {
  return request.get<AbstractResponse<object, PricingResponse>>(
    `${URL}/api/VpricingListFiltered` +
      prepareQueryParams({
        ctetype: params.ctetype,
        entity: params.entity,
        entityid: params.entityid,
        offerid: params.offerid,
        prcode: params.prcode,
        tpid: params.tpid,
        filtersPricing: params.filtersPricing,
        filtersValue: params.filtersValue,
      } as any)
  );
}

export function getPricingList(params: GetPricingListParams) {
  return request.get<AbstractResponse<object, ViewPricingList>>(
    `${URL}/api/VpricingList` +
      prepareQueryParams({
        ctetype: params.ctetype,
        flagdefault: params.flagdefault,
        mgid: params.mgid,
        priid: params.priid,
        prilabel: params.prilabel,
      } as any)
  );
}

export interface AddPricingListParams {
  req: ViewPricingList;
}
/**
 * @tags Pricing Controller
 * @summary addPricingList
 */
export function addPricingList(params: AddPricingListParams) {
  return request.post<AbstractResponse<object, ViewPricingList>>(
    `${URL}/api/VpricingList`,
    params.req
  );
}
export interface RemovePricingListParams {
  req: ViewPricingList;
}
/**
 * @tags Pricing Controller
 * @summary removePricingList
 */
export function removePricingList(params: RemovePricingListParams) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/VpricingList`,
    params.req
  );
}
export interface GetPricingListOfferParams {
  ctetype: string;
  flagdefault: boolean;
  mgid: number;
  offerid: number;
  priid: number;
  prilabel: string;
}

export interface ViewPricingListOffer {
  ctetype: string;
  flagdefault: boolean;
  id: number;
  mgid: number;
  offerid: number;
  priid: number;
  prilabel: string;
}
/**
 * @tags Pricing Controller
 * @summary getPricingListOffer
 */
export function getPricingListOffer(params: GetPricingListOfferParams) {
  return request.get<AbstractResponse<object, ViewPricingListOffer>>(
    `${URL}/api/VpricingListOffer` +
      prepareQueryParams({
        ctetype: params.ctetype,
        flagdefault: params.flagdefault,
        mgid: params.mgid,
        offerid: params.offerid,
        priid: params.priid,
        prilabel: params.prilabel,
      } as any)
  );
}
export interface AddPricingListOfferParams {
  req: ViewPricingListOffer;
}

/**
 * @tags Pricing Controller
 * @summary addPricingListOffer
 */
export function addPricingListOffer(params: AddPricingListOfferParams) {
  return request.post<AbstractResponse<object, ViewPricingListOffer>>(
    `${URL}/api/VpricingListOffer`,
    params.req
  );
}
export interface RemovePricingListOfferParams {
  req: ViewPricingListOffer;
}
/**
 * @tags Pricing Controller
 * @summary removePricingListOffer
 */
export function removePricingListOffer(params: RemovePricingListOfferParams) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/VpricingListOffer`,
    params.req
  );
}

export interface GetPricingListProductParams {
  ctetype: string;
  flagdefault: boolean;
  mgid: number;
  prcode: string;
  priid: number;
  prilabel: string;
}

export interface ViewPricingListProduct {
  ctetype: string;
  flagdefault: boolean;
  id: number;
  mgid: number;
  prcode: string;
  priid: number;
  prilabel: string;
  filterid?: number;
}
export interface AddPricingListProductParams {
  req: ViewPricingListProduct;
}
/**
 * @tags Pricing Controller
 * @summary addPricingListProduct
 */
export function addPricingListProduct(params: AddPricingListProductParams) {
  return request.post<AbstractResponse<object, ViewPricingListProduct>>(
    `${URL}/api/VpricingListProduct`,
    params.req
  );
}
export interface RemovePricingListProductParams {
  req: ViewPricingListProduct;
}
/**
 * @tags Pricing Controller
 * @summary removePricingListProduct
 */
export function removePricingListProduct(
  params: RemovePricingListProductParams
) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/VpricingListProduct`,
    params.req
  );
}
/**
 * @tags Pricing Controller
 * @summary getPricingListProduct
 */
export function getPricingListProduct(params: GetPricingListProductParams) {
  return request.get<AbstractResponse<object, ViewPricingListProduct>>(
    `${URL}/api/VpricingListProduct` +
      prepareQueryParams({
        ctetype: params.ctetype,
        flagdefault: params.flagdefault,
        mgid: params.mgid,
        prcode: params.prcode,
        priid: params.priid,
        prilabel: params.prilabel,
      } as any)
  );
}

/**
 * @tags Pricing Controller
 * @summary getAssetCatalogListByCriteria
 */
export interface GetCommissionByCommcodeParams {
  commcode: string;
}

/**
 * @tags Pricing Controller
 * @summary getCommissionByCommcode
 */
export function getCommissionByCommcode(params: GetCommissionByCommcodeParams) {
  return request.get<AbstractResponse<ParCommissionResponse, object>>(
    `${URL}/api/commcode/${params.commcode}`
  );
}

export interface GetCommissionListByCriteriaParams {
  commcode: string;
  commlabel: string;
  commstatus: string;
  commtype: string;
  tprole: string;
  tpidsupplier?: number;
}

/**
 * @tags Pricing Controller
 * @summary getCommissionListByCriteria
 */
export function getCommissionListByCriteria(
  params: GetCommissionListByCriteriaParams
) {
  return request.get<AbstractResponse<object, ParCommissionResponse>>(
    `${URL}/api/commission` +
      prepareQueryParams({
        commcode: params.commcode,
        commlabel: params.commlabel,
        commstatus: params.commstatus,
        commtype: params.commtype,
        tprole: params.tprole,
        tpidsupplier: params.tpidsupplier,
      } as any)
  );
}

export interface CreateCommissionParams {
  req: ParCommission;
}

/**
 * @tags Pricing Controller
 * @summary createCommission
 */
export function createCommission(params: CreateCommissionParams) {
  return request.post<AbstractResponse<ParCommissionResponse, object>>(
    `${URL}/api/commission`,
    params.req
  );
}

export interface UpdateCommissionParams {
  req: ParCommission;
}

/**
 * @tags Pricing Controller
 * @summary updateCommission
 */
export function updateCommission(params: UpdateCommissionParams) {
  return request.put<AbstractResponse<ParCommissionResponse, object>>(
    `${URL}/api/commission`,
    params.req
  );
}

export interface RemoveCommissionParams {
  commcode: string;
}

/**
 * @tags Pricing Controller
 * @summary removeCommission
 */
export function removeCommission(params: RemoveCommissionParams) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/commission/${params.commcode}`
  );
}

export interface GetCommissionCriteriaParams {
  commcode: string;
}

/**
 * @tags Pricing Controller
 * @summary getCommissionCriteria
 */
export function getCommissionCriteria(params: GetCommissionCriteriaParams) {
  return request.get<AbstractResponse<object, ParCommissionCriteriaResponse>>(
    `${URL}/api/commission/${params.commcode}/criteria`
  );
}

export interface AddCommissionCriteriaParams {
  req: ParCommissionCriteria;
  commcode?: string;
}

/**
 * @tags Pricing Controller
 * @summary addCommissionCriteria
 */
export function addCommissionCriteria(params: AddCommissionCriteriaParams) {
  return request.post<AbstractResponse<object, object>>(
    `${URL}/api/commission/${params.commcode}/criteria`,
    params.req
  );
}

export interface RemoveCommissionCriteriaParams {
  commcode: string;
  criid: number;
}

/**
 * @tags Pricing Controller
 * @summary removeCommissionCriteria
 */
export function removeCommissionCriteria(
  params: RemoveCommissionCriteriaParams
) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/commission/${params.commcode}/criteria/${params.criid}`
  );
}

export interface UpdateCommissionStatusParams {
  commcode: string;
  status: string;
}

/**
 * @tags Pricing Controller
 * @summary updateCommissionStatus
 */
export function updateCommissionStatus(params: UpdateCommissionStatusParams) {
  return request.put<AbstractResponse<ParCommissionResponse, object>>(
    `${URL}/api/commission/${params.commcode}/updateStatus/${params.status}`
  );
}

export interface GetParListScoringParams {
  parcode: string;
}

/**
 * @tags Pricing Controller
 * @summary getParListScoring
 */
export function getParListScoring(params: GetParListScoringParams) {
  return request.get<AbstractResponse<object, ParList>>(
    `${URL}/api/getParListPricing` +
      prepareQueryParams({ parcode: params.parcode } as any)
  );
}

export interface GetCommissionListByTypeParams {
  commtype: string;
  filters: string;
}

/**
 * @tags Pricing Controller
 * @summary getCommissionListByType
 */
export function getCommissionListByType(params: GetCommissionListByTypeParams) {
  return request.get<AbstractResponse<object, ParCommission>>(
    `${URL}/api/prCommissionList` +
      prepareQueryParams({
        commtype: params.commtype,
        filters: params.filters,
      } as any)
  );
}

export interface AssetUseCriteria {
  assetfamily: string;
  assettype: string;
  assetcategory: string;
  catalogid: number;
  attcode: string;
  attvalue: number;
}
export interface AssetRVCriteria {
  assetsegment: string;
  assetfamily: string;
  assettype: string;
  assetcategory: string;
  assetmodel: string;
  assetbrand: string;
  assetbrandmodel: string;
  assetvariant: string;
  catalogid: number;
  assetid: number;
  assetnetamount: number;
  assetfinamount: number;
}
export interface FilteringCriteria {
  critcode: string;
  critvalue: string;
}

export interface prFilteringCriteria {
  assetUseCriteria: Array<AssetUseCriteria>;
  assetRVCriteria: Array<AssetRVCriteria>;
  flagApplyAssetUse?: boolean;
  flagApplyAttributesExtendDurationValues?: boolean;
  flagApplyAttributesExtendFirstRentalValues?: boolean;
  flagApplyAttributesExtendRVValues?: boolean;
  flagApplyAttributesExtendRateValues?: boolean;
  flagApplyExtendDurationValues?: boolean;
  flagApplyExtendFirstRentalValues?: boolean;
  flagApplyExtendRVValues?: boolean;
  flagApplyExtendRateValues?: boolean;
  offerCriteria: Array<FilteringCriteria>;
  prcode: string;
  tpid: number;
  tpidbroker: number;
  tpidmanufacturer: number;
}

export interface GetOfferListParams {
  duration: number;
  filters: string;
  finamount: number;
  prcode: string;
}

/**
 * @tags Pricing Controller
 * @summary getOfferList
 */
export function getprOfferList(params: GetOfferListParams) {
  return request.get<AbstractResponse<object, ParOfferResponse>>(
    `${URL}/api/prOfferList` +
      prepareQueryParams({
        duration: params.duration,
        filters: params.filters,
        finamount: params.finamount,
        prcode: params.prcode,
      } as any)
  );
}

export interface GetOfferDetailByOfferIdParams {
  offerid: number;
  filtersList?: prFilteringCriteria;
  duration?: number;
}

/**
 * @tags Pricing Controller
 * @summary getOfferDetailByOfferId
 */
export function getprOfferDetailByOfferId(
  params: GetOfferDetailByOfferIdParams
) {
  return request.post<AbstractResponse<ParOfferResponse, object>>(
    `${URL}/api/prOfferList/${params.offerid}/${params.duration ?? 0}`,
    params.filtersList
  );
}

export interface GetOfferListByCatalogIDParams {
  catalogid: number;
  filters: string;
  prcode: string;
}

/**
 * @tags Pricing Controller
 * @summary getOfferListByCatalogID
 */
export function getOfferListByCatalogID(params: GetOfferListByCatalogIDParams) {
  return request.get<AbstractResponse<object, ParOfferResponse>>(
    `${URL}/api/prOfferListByCatalogID` +
      prepareQueryParams({
        catalogid: params.catalogid,
        filters: params.filters,
        prcode: params.prcode,
      } as any)
  );
}

export interface GetOfferListByPrcodeAndMgidParams {
  filters: prFilteringCriteria;
  prcode?: string;
}

/**
 * @tags Pricing Controller
 * @summary getOfferListByPrcodeAndMgid
 */
export function getprOfferListByPrcodeAndMgid(
  params: GetOfferListByPrcodeAndMgidParams
) {
  return request.post<AbstractResponse<object, ParOfferResponse>>(
    `${URL}/api/prOfferListByPrcodeAndMgid`,
    params.filters
  );
}

export interface GetPricingDetailParams {
  filtersList?: prFilteringCriteria;
  priid: number;
}

/**
 * @tags Pricing Controller
 * @summary getPricingDetail
 */
export function getPricingDetail(params: GetPricingDetailParams) {
  return request.post<AbstractResponse<object, PricingResponse>>(
    `${URL}/api/prPricingDetail/${params.priid}`,
    params.filtersList
  );
}

export function getApplicablePricingCommissionList(
  params: GetPricingDetailParams
) {
  return request.post<AbstractResponse<object, ParCommissionResponse>>(
    `${URL}/api/prPricingCommission/${params.priid}`,
    params.filtersList
  );
}

export interface GetPricingListByTypeandCatParams {
  ctecategory: string;
  ctetype: string;
  filters: string;
  finamount: number;
  offerid: number;
}

/**
 * @tags Pricing Controller
 * @summary getPricingListByTypeandCat
 */
export function getPricingListByTypeandCat(
  params: GetPricingListByTypeandCatParams
) {
  return request.get<AbstractResponse<object, PricingResponse>>(
    `${URL}/api/prPricingList` +
      prepareQueryParams({
        ctecategory: params.ctecategory,
        ctetype: params.ctetype,
        filters: params.filters,
        finamount: params.finamount,
        offerid: params.offerid,
      } as any)
  );
}

export interface GetPricingPackDetailParams {
  filtersList?: prFilteringCriteria;
  packid: number;
}

/**
 * @tags Pricing Controller
 * @summary getPricingPackDetail
 */
export function getPricingPackDetail(params: GetPricingPackDetailParams) {
  return request.post<AbstractResponse<object, PricingResponse>>(
    `${URL}/api/prPricingPackDetail/${params.packid}`,
    params.filtersList
  );
}

export interface GetPricingPackListParams {
  catalogid: number;
  duration: number;
  filters: string;
  filtersList?: prFilteringCriteria;
  finamount: number;
  mgid: number;
  offerid: number;
  prcode: string;
}

/**
 * @tags Pricing Controller
 * @summary getPricingPackList
 */
export function getPricingPackList(params: GetPricingPackListParams) {
  return request.post<AbstractResponse<object, PricingPackResponse>>(
    `${URL}/api/prPricingPackList`,
    params.filtersList
    /*prepareQueryParams({
        catalogid: params.catalogid,
        duration: params.duration,
        filters: params.filters,
        filterList:params.filtersList,
        finamount: params.finamount,
        mgid: params.mgid,
        offerid: params.offerid,
        prcode: params.prcode,
      } as any)*/
  );
}

export interface GetServiceListByTypeParams {
  filters: string;
  servtype: string;
}

/**
 * @tags Pricing Controller
 * @summary getServiceListByType
 */
export function getServiceListByType(params: GetServiceListByTypeParams) {
  return request.get<AbstractResponse<object, ParService>>(
    `${URL}/api/prServiceList` +
      prepareQueryParams({
        filters: params.filters,
        servtype: params.servtype,
      } as any)
  );
}

export interface GetServiceListByCategoryParams {
  filters: string;
  servcategory: string;
}

/**
 * @tags Pricing Controller
 * @summary getServiceListByCategory
 */
export function getServiceListByCategory(
  params: GetServiceListByCategoryParams
) {
  return request.get<AbstractResponse<object, ParService>>(
    `${URL}/api/prServiceListByCat` +
      prepareQueryParams({
        filters: params.filters,
        servcategory: params.servcategory,
      } as any)
  );
}

export interface GetParPricingListByCriteriaParams {
  ctecategory: string;
  ctetype: string;
  duration: number;
  finamount: number;
  priid: number;
  prilabel: string;
  pristatus: string;
}

/**
 * @tags Pricing Controller
 * @summary getParPricingListByCriteria
 */
export function getParPricingListByCriteria(
  params: GetParPricingListByCriteriaParams
) {
  return request.get<AbstractResponse<object, ParPricingListResponse>>(
    `${URL}/api/pricing` +
      prepareQueryParams({
        ctecategory: params.ctecategory,
        ctetype: params.ctetype,
        duration: params.duration,
        finamount: params.finamount,
        priid: params.priid,
        prilabel: params.prilabel,
        pristatus: params.pristatus,
      } as any)
  );
}

export interface CreatePricingParams {
  req: ParPricing;
}

/**
 * @tags Pricing Controller
 * @summary createPricing
 */
export function createPricing(params: CreatePricingParams) {
  return request.post<AbstractResponse<ParPricingResponse, object>>(
    `${URL}/api/pricing`,
    params.req
  );
}

export interface UpdatePricingParams {
  req: ParPricing;
}

/**
 * @tags Pricing Controller
 * @summary updatePricing
 */
export function updatePricing(params: UpdatePricingParams) {
  return request.put<AbstractResponse<ParPricingResponse, object>>(
    `${URL}/api/pricing`,
    params.req
  );
}

export interface GetParPricingByPriidParams {
  priid: number;
}

/**
 * @tags Pricing Controller
 * @summary getParPricingByPriid
 */
export function getParPricingByPriid(params: GetParPricingByPriidParams) {
  return request.get<AbstractResponse<ParPricingResponse, object>>(
    `${URL}/api/pricing/${params.priid}`
  );
}

export interface GetPricingCommissionParams {
  priid: number;
}

/**
 * @tags Pricing Controller
 * @summary getPricingCommission
 */
export function getPricingCommission(params: GetPricingCommissionParams) {
  return request.get<AbstractResponse<object, ParPricingCommissionResponse>>(
    `${URL}/api/pricing/${params.priid}/commission`
  );
}

export interface AddPricingCommissionParams {
  req: ParPricingCommission;
  priid?: number;
}

/**
 * @tags Pricing Controller
 * @summary addPricingCommission
 */
export function addPricingCommission(params: AddPricingCommissionParams) {
  return request.post<AbstractResponse<object, object>>(
    `${URL}/api/pricing/${params.priid}/commission`,
    params.req
  );
}

export interface UpdatePricingCommissionParams {
  req: ParPricingCommission;
  priid?: number;
}

/**
 * @tags Pricing Controller
 * @summary updatePricingCommission
 */
export function updatePricingCommission(params: UpdatePricingCommissionParams) {
  return request.put<AbstractResponse<object, object>>(
    `${URL}/api/pricing/${params.priid}/commission`,
    params.req
  );
}

export interface GetPricingCommissionDetailParams {
  prcommid: number;
  priid: number;
}

/**
 * @tags Pricing Controller
 * @summary getPricingCommissionDetail
 */
export function getPricingCommissionDetail(
  params: GetPricingCommissionDetailParams
) {
  return request.get<AbstractResponse<ParPricingCommissionResponse, object>>(
    `${URL}/api/pricing/${params.priid}/commission/${params.prcommid}`
  );
}

export interface RemovePricingCommissionParams {
  prcommid: number;
  priid: number;
}

/**
 * @tags Pricing Controller
 * @summary removePricingCommission
 */
export function removePricingCommission(params: RemovePricingCommissionParams) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/pricing/${params.priid}/commission/${params.prcommid}`
  );
}

export interface GetPricingCommissionCriteriaParams {
  prcommid: number;
  priid: number;
}

/**
 * @tags Pricing Controller
 * @summary getPricingCommissionCriteria
 */
export function getPricingCommissionCriteria(
  params: GetPricingCommissionCriteriaParams
) {
  return request.get<AbstractResponse<object, ParPricingCommCriteriaResponse>>(
    `${URL}/api/pricing/${params.priid}/commission/${params.prcommid}/criteria`
  );
}

export interface AddPricingCommissionCriteriaParams {
  req: ParPricingCommCriteria;
  priid?: number;
  prcommid: number;
}

/**
 * @tags Pricing Controller
 * @summary addPricingCommissionCriteria
 */
export function addPricingCommissionCriteria(
  params: AddPricingCommissionCriteriaParams
) {
  return request.post<AbstractResponse<object, object>>(
    `${URL}/api/pricing/${params.priid}/commission/${params.prcommid}/criteria`,
    params.req
  );
}

export interface RemovePricingCommissionCriteriaParams {
  criid: number;
  prcommid: number;
  priid: number;
}

/**
 * @tags Pricing Controller
 * @summary removePricingCommissionCriteria
 */
export function removePricingCommissionCriteria(
  params: RemovePricingCommissionCriteriaParams
) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/pricing/${params.priid}/commission/${params.prcommid}/criteria/${params.criid}`
  );
}

export interface DuplicatePricingCommissionParams {
  prcommid: number;
  priid: number;
}

/**
 * @tags Pricing Controller
 * @summary duplicatePricingCommission
 */
export function duplicatePricingCommission(
  params: DuplicatePricingCommissionParams
) {
  return request.get<AbstractResponse<ParPricingCommissionResponse, object>>(
    `${URL}/api/pricing/${params.priid}/commission/${params.prcommid}/duplicate`
  );
}

export interface UpdatePricingCommissionStatusParams {
  prcommid: number;
  priid: number;
  status: string;
}

/**
 * @tags Pricing Controller
 * @summary updatePricingCommissionStatus
 */
export function updatePricingCommissionStatus(
  params: UpdatePricingCommissionStatusParams
) {
  return request.put<AbstractResponse<ParPricingCommissionResponse, object>>(
    `${URL}/api/pricing/${params.priid}/commission/${params.prcommid}/updateStatus/${params.status}`
  );
}

export interface GetPricingCriteriaParams {
  priid: number;
}

/**
 * @tags Pricing Controller
 * @summary getPricingCriteria
 */
export function getPricingCriteria(params: GetPricingCriteriaParams) {
  return request.get<AbstractResponse<object, ParPricingCriteriaResponse>>(
    `${URL}/api/pricing/${params.priid}/criteria`
  );
}

export interface AddPricingCriteriaParams {
  req: ParPricingCriteria;
  priid?: number;
}

/**
 * @tags Pricing Controller
 * @summary addPricingCriteria
 */
export function addPricingCriteria(params: AddPricingCriteriaParams) {
  return request.post<AbstractResponse<object, object>>(
    `${URL}/api/pricing/${params.priid}/criteria`,
    params.req
  );
}

export interface RemovePricingCriteriaParams {
  criid: number;
  priid: number;
}

/**
 * @tags Pricing Controller
 * @summary removePricingCriteria
 */
export function removePricingCriteria(params: RemovePricingCriteriaParams) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/pricing/${params.priid}/criteria/${params.criid}`
  );
}

export interface DuplicatePricingParams {
  priid: number;
}

/**
 * @tags Pricing Controller
 * @summary duplicatePricing
 */
export function duplicatePricing(params: DuplicatePricingParams) {
  return request.get<AbstractResponse<ParPricingResponse, object>>(
    `${URL}/api/pricing/${params.priid}/duplicate`
  );
}

export interface GetPricingStepParams {
  priid: number;
}

/**
 * @tags Pricing Controller
 * @summary getPricingStep
 */
export function getPricingStep(params: GetPricingStepParams) {
  return request.get<AbstractResponse<object, ParPricingStep>>(
    `${URL}/api/pricing/${params.priid}/step`
  );
}

export interface AddPricingStepParams {
  req: ParPricingStep;
  priid?: number;
}

/**
 * @tags Pricing Controller
 * @summary addPricingStep
 */
export function addPricingStep(params: AddPricingStepParams) {
  return request.post<AbstractResponse<ParPricingStep, object>>(
    `${URL}/api/pricing/${params.priid}/step`,
    params.req
  );
}

export interface UpdatePricingStepParams {
  ctesid: number;
  priid: number;
  req: ParPricingStep;
}

/**
 * @tags Pricing Controller
 * @summary updatePricingStep
 */
export function updatePricingStep(params: UpdatePricingStepParams) {
  return request.put<AbstractResponse<ParPricingStep, object>>(
    `${URL}/api/pricing/${params.priid}/step/${params.ctesid}`,
    params.req
  );
}

export interface RemovePricingStepParams {
  ctesid: number;
  priid: number;
}

/**
 * @tags Pricing Controller
 * @summary removePricingStep
 */
export function removePricingStep(params: RemovePricingStepParams) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/pricing/${params.priid}/step/${params.ctesid}`
  );
}

export interface UpdatePricingStatusParams {
  priid: number;
  status: string;
}

/**
 * @tags Pricing Controller
 * @summary updatePricingStatus
 */
export function updatePricingStatus(params: UpdatePricingStatusParams) {
  return request.put<AbstractResponse<ParPricingResponse, object>>(
    `${URL}/api/pricing/${params.priid}/updateStatus/${params.status}`
  );
}

export interface GetParPricingPackListByCriteriaParams {
  packid: number;
  packlabel: string;
  packstatus: string;
}

/**
 * @tags Pricing Controller
 * @summary getParPricingPackListByCriteria
 */
export function getParPricingPackListByCriteria(
  params: GetParPricingPackListByCriteriaParams
) {
  return request.get<AbstractResponse<object, ParPricingPackResponse>>(
    `${URL}/api/pricingPack` +
      prepareQueryParams({
        packid: params.packid,
        packlabel: params.packlabel,
        packstatus: params.packstatus,
      } as any)
  );
}

export interface CreatePricingPackParams {
  req: ParPricingPack;
}

/**
 * @tags Pricing Controller
 * @summary createPricingPack
 */
export function createPricingPack(params: CreatePricingPackParams) {
  return request.post<AbstractResponse<ParPricingPackResponse, object>>(
    `${URL}/api/pricingPack`,
    params.req
  );
}

export interface UpdatePricingPackParams {
  req: ParPricingPack;
}

/**
 * @tags Pricing Controller
 * @summary updatePricingPack
 */
export function updatePricingPack(params: UpdatePricingPackParams) {
  return request.put<AbstractResponse<ParPricingPackResponse, object>>(
    `${URL}/api/pricingPack`,
    params.req
  );
}

export interface GetParPricingPackByPriidParams {
  packid: number;
}

/**
 * @tags Pricing Controller
 * @summary getParPricingPackByPriid
 */
export function getParPricingPackByPriid(
  params: GetParPricingPackByPriidParams
) {
  return request.get<AbstractResponse<ParPricingPackResponse, object>>(
    `${URL}/api/pricingPack/${params.packid}`
  );
}

export interface GetPricingPackCriteriaParams {
  packid: number;
}

/**
 * @tags Pricing Controller
 * @summary getPricingPackCriteria
 */
export function getPricingPackCriteria(params: GetPricingPackCriteriaParams) {
  return request.get<AbstractResponse<object, ParPricingPackCriteriaResponse>>(
    `${URL}/api/pricingPack/${params.packid}/criteria`
  );
}

export interface AddPricingPackCriteriaParams {
  packid?: number;
  req: ParPricingPackCriteria;
}

/**
 * @tags Pricing Controller
 * @summary addPricingPackCriteria
 */
export function addPricingPackCriteria(params: AddPricingPackCriteriaParams) {
  return request.post<AbstractResponse<object, object>>(
    `${URL}/api/pricingPack/${params.packid}/criteria`,
    params.req
  );
}

export interface RemovePricingPackCriteriaParams {
  criid: number;
  packid: number;
}

/**
 * @tags Pricing Controller
 * @summary removePricingPackCriteria
 */
export function removePricingPackCriteria(
  params: RemovePricingPackCriteriaParams
) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/pricingPack/${params.packid}/criteria/${params.criid}`
  );
}

export interface GetPricingPackDetailListParams {
  packid: number;
}

/**
 * @tags Pricing Controller
 * @summary getPricingPackDetailList
 */
export function getPricingPackDetailList(
  params: GetPricingPackDetailListParams
) {
  return request.get<AbstractResponse<object, ParPricingPackDetailResponse>>(
    `${URL}/api/pricingPack/${params.packid}/detail`
  );
}

export interface AddPricingPackDetailParams {
  packid?: number;
  req: ParPricingPackDetail;
}

/**
 * @tags Pricing Controller
 * @summary addPricingPackDetail
 */
export function addPricingPackDetail(params: AddPricingPackDetailParams) {
  return request.post<AbstractResponse<object, object>>(
    `${URL}/api/pricingPack/${params.packid}/detail`,
    params.req
  );
}

export interface UpdatePricingPackDetailParams {
  packid?: number;
  req: ParPricingPackDetail;
}

/**
 * @tags Pricing Controller
 * @summary updatePricingPackDetail
 */
export function updatePricingPackDetail(params: UpdatePricingPackDetailParams) {
  return request.put<AbstractResponse<object, object>>(
    `${URL}/api/pricingPack/${params.packid}/detail`,
    params.req
  );
}

export interface RemovePricingPackDetailParams {
  packid: number;
  priid: number;
}

/**
 * @tags Pricing Controller
 * @summary removePricingPackDetail
 */
export function removePricingPackDetail(params: RemovePricingPackDetailParams) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/pricingPack/${params.packid}/detail/${params.priid}`
  );
}

export interface DuplicatePricingPackParams {
  packid: number;
}

/**
 * @tags Pricing Controller
 * @summary duplicatePricingPack
 */
export function duplicatePricingPack(params: DuplicatePricingPackParams) {
  return request.get<AbstractResponse<ParPricingPackResponse, object>>(
    `${URL}/api/pricingPack/${params.packid}/duplicate`
  );
}

export interface UpdatePricingPackStatusParams {
  packid: number;
  status: string;
}

/**
 * @tags Pricing Controller
 * @summary updatePricingPackStatus
 */
export function updatePricingPackStatus(params: UpdatePricingPackStatusParams) {
  return request.put<AbstractResponse<ParPricingPackResponse, object>>(
    `${URL}/api/pricingPack/${params.packid}/updateStatus/${params.status}`
  );
}

export interface GetServiceListByCriteriaParams {
  servcategory: string;
  servcode: string;
  servlabel: string;
  servstatus: string;
  servtype: string;
  tpidsupplier: number;
}

/**
 * @tags Pricing Controller
 * @summary getServiceListByCriteria
 */
export function getServiceListByCriteria(
  params: GetServiceListByCriteriaParams
) {
  return request.get<AbstractResponse<object, ParServiceResponse>>(
    `${URL}/api/service` +
      prepareQueryParams({
        servcategory: params.servcategory,
        servcode: params.servcode,
        servlabel: params.servlabel,
        servstatus: params.servstatus,
        servtype: params.servtype,
        tpidsupplier: params.tpidsupplier,
      } as any)
  );
}

export interface CreateServiceParams {
  req: ParService;
}

/**
 * @tags Pricing Controller
 * @summary createService
 */
export function createService(params: CreateServiceParams) {
  return request.post<AbstractResponse<ParServiceResponse, object>>(
    `${URL}/api/service`,
    params.req
  );
}

export interface GetServiceByServcodeParams {
  servcode: string;
}

/**
 * @tags Pricing Controller
 * @summary getServiceByServcode
 */
export function getServiceByServcode(params: GetServiceByServcodeParams) {
  return request.get<AbstractResponse<ParServiceResponse, object>>(
    `${URL}/api/service/${params.servcode}`
  );
}

export interface UpdateServiceParams {
  servcode: string;
  req: ParService;
}

/**
 * @tags Pricing Controller
 * @summary updateService
 */
export function updateService(params: UpdateServiceParams) {
  return request.put<AbstractResponse<ParServiceResponse, object>>(
    `${URL}/api/service/${params.servcode}`,
    params.req
  );
}

export interface RemoveServiceParams {
  servcode: string;
}

/**
 * @tags Pricing Controller
 * @summary removeService
 */
export function removeService(params: RemoveServiceParams) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/service/${params.servcode}`
  );
}

export interface GetServiceCriteriaParams {
  servcode: string;
}

/**
 * @tags Pricing Controller
 * @summary getServiceCriteria
 */
export function getServiceCriteria(params: GetServiceCriteriaParams) {
  return request.get<AbstractResponse<object, ParServiceCriteriaResponse>>(
    `${URL}/api/service/${params.servcode}/criteria`
  );
}

export interface AddServiceCriteriaParams {
  servcode?: string;
  req: ParServiceCriteria;
}

/**
 * @tags Pricing Controller
 * @summary addServiceCriteria
 */
export function addServiceCriteria(params: AddServiceCriteriaParams) {
  return request.post<AbstractResponse<object, object>>(
    `${URL}/api/service/${params.servcode}/criteria`,
    params.req
  );
}

export interface RemoveServiceCriteriaParams {
  criid: number;
  servcode: string;
}

/**
 * @tags Pricing Controller
 * @summary removeServiceCriteria
 */
export function removeServiceCriteria(params: RemoveServiceCriteriaParams) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/service/${params.servcode}/criteria/${params.criid}`
  );
}

export interface GetServiceStepParams {
  servcode: string;
}

/**
 * @tags Pricing Controller
 * @summary getServiceStep
 */
export function getServiceStep(params: GetServiceStepParams) {
  return request.get<AbstractResponse<object, ParServiceStep>>(
    `${URL}/api/service/${params.servcode}/step`
  );
}

export interface AddServiceStepParams {
  servcode?: string;
  req: ParServiceStep;
}

/**
 * @tags Pricing Controller
 * @summary addServiceStep
 */
export function addServiceStep(params: AddServiceStepParams) {
  return request.post<AbstractResponse<ParServiceStep, object>>(
    `${URL}/api/service/${params.servcode}/step`,
    params.req
  );
}

export interface UpdateServiceStepParams {
  req: ParServiceStep;
  servcode: string;
  stepid: number;
}

/**
 * @tags Pricing Controller
 * @summary updateServiceStep
 */
export function updateServiceStep(params: UpdateServiceStepParams) {
  return request.put<AbstractResponse<ParServiceStep, object>>(
    `${URL}/api/service/${params.servcode}/step/${params.stepid}`,
    params.req
  );
}

export interface RemoveServiceStepParams {
  servcode: string;
  stepid: number;
}

/**
 * @tags Pricing Controller
 * @summary removeServiceStep
 */
export function removeServiceStep(params: RemoveServiceStepParams) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/service/${params.servcode}/step/${params.stepid}`
  );
}

export interface UpdateServiceStatusParams {
  servcode: string;
  status: string;
}

/**
 * @tags Pricing Controller
 * @summary updateServiceStatus
 */
export function updateServiceStatus(params: UpdateServiceStatusParams) {
  return request.put<AbstractResponse<ParServiceResponse, object>>(
    `${URL}/api/service/${params.servcode}/updateStatus/${params.status}`
  );
}

/**
 * @tags Pricing Controller
 * @summary version
 */
export function version() {
  return request.get<string>(`${URL}/api/version`);
}

export interface SetPricingDefaultParams {
  ctetype: string;
  filterid: number;
  mgid: number;
  offerid: number;
  parcode: string;
  priid: number;
  pritype: string;
  target: string;
}

/**
 * @tags Pricing Controller
 * @summary setPricingDefault
 */
export function setPricingDefault(params: SetPricingDefaultParams) {
  return request.put<AbstractResponse<object, object>>(
    `${URL}/api/mgpricingdefaultvalue/${params.filterid}/${params.target}` +
      prepareQueryParams({
        ctetype: params.ctetype,
        mgid: params.mgid,
        offerid: params.offerid,
        parcode: params.parcode,
        priid: params.priid,
        pritype: params.pritype,
      } as any)
  );
}

export interface GetMgUserJobAuthorizationByCriteriaParams {
  attcode: string;
  mgid: number;
  offerid: number;
  prcode: string;
  priid: number;
  userjob: string;
  authtype: string;
  tpid: number;
  tprole: string;
  userid: number;
  rvid?: number;
}

/**
 * @tags Pricing Controller
 * @summary getMgUserJobAuthorizationByCriteria
 */
export function getMgUserJobAuthorizationByCriteria(
  params: GetMgUserJobAuthorizationByCriteriaParams
) {
  return request.get<AbstractResponse<object, MgUserJobAuthorizationResponse>>(
    `${URL}/api/userJobAuthorization` +
      prepareQueryParams({
        attcode: params.attcode,
        mgid: params.mgid,
        offerid: params.offerid,
        prcode: params.prcode,
        priid: params.priid,
        userjob: params.userjob,
        authtype: params.authtype,
        tpid: params.tpid,
        tprole: params.tprole,
        userid: params.userid,
        rvid: params.rvid,
      } as any)
  );
}

export interface AddMgUserJobAuthorizationParams {
  request: MgUserJobAuthorizationRequest;
}

/**
 * @tags Pricing Controller
 * @summary addMgUserJobAuthorization
 */
export function addMgUserJobAuthorization(
  params: AddMgUserJobAuthorizationParams
) {
  return request.post<AbstractResponse<MgUserJobAuthorizationResponse, object>>(
    `${URL}/api/userJobAuthorization`,
    params.request
  );
}

export interface UpdateMgUserJobAuthorizationParams {
  authid: number;
  request: MgUserJobAuthorizationRequest;
}

/**
 * @tags Pricing Controller
 * @summary updateMgUserJobAuthorization
 */
export function updateMgUserJobAuthorization(
  params: UpdateMgUserJobAuthorizationParams
) {
  return request.put<AbstractResponse<MgUserJobAuthorizationResponse, object>>(
    `${URL}/api/userJobAuthorization/${params.authid}`,
    params.request
  );
}

export interface RemoveMgUserJobAuthorizationParams {
  authid: number;
}

/**
 * @tags Pricing Controller
 * @summary removeMgUserJobAuthorization
 */
export function removeMgUserJobAuthorization(
  params: RemoveMgUserJobAuthorizationParams
) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/userJobAuthorization/${params.authid}`
  );
}

export interface ParAssetUseResponse {
  assetid: number;
  attcode: string;
  catalogid: number;
  condid: number;
  defaultvalue: number;
  maxvalue: number;
  minvalue: number;
  useid: number;
  uselabel: string;
  useunitperiod: string;
  useunittype: string;
  usevalue: number;
  usevaluetype: string;
}
export interface ParAssetUseRequest {
  assetcategory: string;
  assetfamily: string;
  assetid: number;
  assettype: string;
  catalogid: number;
  offerid: number;
  ofrid: number;
  ofrtype: string;
  prcode: string;
}
export interface ConfigParAssetUseResponse {
  assetcategory: string;
  assetcategorylabel: string;
  assetfamily: string;
  assetfamilylabel: string;
  assettype: string;
  assettypelabel: string;
  attcode: string;
  attcodelabel: string;
  catalogid: number;
  mgid: number;
  nbconditions: number;
  cataloglabel: string;
  proccodeexceed: string;
  taskidtargetexceed: number;
  useid: number;
  usereqreceivertype: string;
  userequesttype: string;
  userid: number;
  userrequestroleprofile: string;
  useunitperiod: string;
  useunitperiodlabel: string;
  useunittype: string;
  useunittypelabel: string;
  userequesttypelabel: string;
  usereqreceivertypelabel: string;
  userrequestroleprofilelabel: string;
  username: string;
  proccodeexceedlabel: string;
  taskidtargetexceedlabel: string;
  defaultvalue: number;
  maxvalue: number;
  minvalue: number;
  priidexceed: number;
}
export interface ConfigParAssetUseRequest {
  assetcategory: string;
  assetfamily: string;
  assettype: string;
  attcode: string;
  catalogid: number;
  mgid: number;
  proccodeexceed: string;
  taskidtargetexceed: number;
  useid: number;
  usereqreceivertype: string;
  userequesttype: string;
  userid: number;
  userrequestroleprofile: string;
  useunitperiod: string;
  useunittype: string;
  defaultvalue: number;
  maxvalue: number;
  minvalue: number;
  priidexceed: number;
}

export interface ParAssetUseConditionRequest {
  condid: number;
  defaultvalue: number;
  maxvalue: number;
  minvalue: number;
  offerid: number;
  ofrid: number;
  ofrtype: string;
  prcode: string;
  priidexceed: number;
  useid: number;
}

export interface ParAssetUseConditionResponse {
  condid: number;
  defaultvalue: number;
  maxvalue: number;
  minvalue: number;
  priidexceed: number;
  priidexceedlabel: string;
  offerid: number;
  ofrid: number;
  ofrtype: string;
  prcode: string;

  useid: number;
}

export interface GetParAssetUseByFiltersParams {
  parAssetRequest: Array<ParAssetUseRequest>;
}

/**
 * @tags Par Asset Use Controller
 * @summary getParAssetUseByFilters
 */
export function getParAssetUseByFilters(params: GetParAssetUseByFiltersParams) {
  return request.post<AbstractResponse<object, ParAssetUseResponse>>(
    `${URL}/api/parassetuse`,
    params.parAssetRequest
  );
}
export interface GetParAssetUseByCriteriaParams {
  assetcategory: string;
  assetfamily: string;
  assettype: string;
  attcode: string;
  mgid: number;
  offerid: number;
  catalogid: number;
  useid: number;
  prcode: string;
}

/**
 * @tags Par Asset Use Controller
 * @summary getParAssetUseByCriteria
 */
export function getParAssetUseByCriteria(
  params: GetParAssetUseByCriteriaParams
) {
  return request.get<AbstractResponse<object, ConfigParAssetUseResponse>>(
    `${URL}/api/config/parassetuse` +
      prepareQueryParams({
        assetcategory: params.assetcategory,
        assetfamily: params.assetfamily,
        assettype: params.assettype,
        attcode: params.attcode,
        mgid: params.mgid,
        offerid: params.offerid,
        prcode: params.prcode,
        catalogid: params.catalogid,
        useid: params.useid,
      } as any)
  );
}
export interface GetParAssetUseByUseidParams {
  useid: number;
}

/**
 * @tags Par Asset Use Controller
 * @summary getParAssetUseByUseid
 */
export function getParAssetUseByUseid(params: GetParAssetUseByUseidParams) {
  return request.get<AbstractResponse<ConfigParAssetUseResponse, object>>(
    `${URL}/api/config/parassetuse/${params.useid}`
  );
}
export interface AddParAssetUseParams {
  parassetUseReq: ConfigParAssetUseRequest;
}

/**
 * @tags Par Asset Use Controller
 * @summary addParAssetUse
 */
export function addParAssetUse(params: AddParAssetUseParams) {
  return request.post<AbstractResponse<ConfigParAssetUseResponse, object>>(
    `${URL}/api/config/parassetuse`,
    params.parassetUseReq
  );
}

export interface UpdateParAssetUseParams {
  parassetUseReq: ConfigParAssetUseRequest;
  useid: number;
}

/**
 * @tags Par Asset Use Controller
 * @summary updateParAssetUse
 */
export function updateParAssetUse(params: UpdateParAssetUseParams) {
  return request.put<AbstractResponse<ConfigParAssetUseResponse, object>>(
    `${URL}/api/config/parassetuse/${params.useid}`,
    params.parassetUseReq
  );
}

export interface RemoveParAssetUseParams {
  useid?: number;
}

/**
 * @tags Par Asset Use Controller
 * @summary removeParAssetUse
 */
export function removeParAssetUse(params: RemoveParAssetUseParams) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/config/parassetuse/${params.useid}` +
      prepareQueryParams({ useid: params.useid } as any)
  );
}

export interface AddParAssetUseConditionParams {
  parassetUseReq: ParAssetUseConditionRequest;
}

/**
 * @tags Par Asset Use Controller
 * @summary addParAssetUseCondition
 */
export function addParAssetUseCondition(params: AddParAssetUseConditionParams) {
  return request.post<AbstractResponse<object, object>>(
    `${URL}/api/config/parassetusecondition`,
    params.parassetUseReq
  );
}
export interface UpdateParAssetUseConditionParams {
  condid: number;
  request: ParAssetUseConditionRequest;
}

/**
 * @tags Par Asset Use Controller
 * @summary updateParAssetUseCondition
 */
export function updateParAssetUseCondition(
  params: UpdateParAssetUseConditionParams
) {
  return request.put<AbstractResponse<ParAssetUseConditionResponse, object>>(
    `${URL}/api/config/parassetusecondition/${params.condid}`,
    params.request
  );
}

export interface RemoveParAssetUseConditionParams {
  condid: number;
}

/**
 * @tags Par Asset Use Controller
 * @summary removeParAssetUseCondition
 */
export function removeParAssetUseCondition(
  params: RemoveParAssetUseConditionParams
) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/config/parassetusecondition/${params.condid}`
  );
}

export interface GetParAssetUseConditionListByUseIDParams {
  useid: number;
}

/**
 * @tags Par Asset Use Controller
 * @summary getParAssetUseConditionListByUseID
 */
export function getParAssetUseConditionListByUseID(
  params: GetParAssetUseConditionListByUseIDParams
) {
  return request.get<AbstractResponse<object, ParAssetUseConditionResponse>>(
    `${URL}/api/config/parassetusecondition/${params.useid}`
  );
}

export interface MgofferPk {
  mgid: number;
  offerid: number;
}

export interface MgOffer {
  enddate: string;
  mgOfferpk: MgofferPk;
  startdate: string;
}

export interface AddMgOfferParams {
  request: MgOffer;
}

/**
 * @tags Parameters Controller
 * @summary addMgOffer
 */
export function addMgOffer(params: AddMgOfferParams) {
  return request.post<AbstractResponse<MgOffer, object>>(
    `${URL}/api/mgoffer`,
    params.request
  );
}

export interface RemoveMgOfferParams {
  mgid: number;
  offerid: number;
}

/**
 * @tags Parameters Controller
 * @summary removeMgOffer
 */
export function removeMgOffer(params: RemoveMgOfferParams) {
  return request.delete<AbstractResponse<MgOffer, object>>(
    `${URL}/api/mgoffer/${params.mgid}/${params.offerid}`
  );
}

export interface ParOfferCriteria {
  criid: number;
  critcode: string;
  critvalue: string;
  offerid: number;
}

export interface ParOfferCriteriaResponse {
  applicationrule: string;
  criid: number;
  critcode: string;
  critcodelabel: string;
  critoperand: string;
  critvalue: string;
  critvaluelabel: string;
  critvaluemax: string;
  listvalue: string;
  offerid: number;
}

export interface ParOfferListResponse {
  durationmax: number;
  durationmin: number;
  enddate: string;
  finamountmax: number;
  finamountmin: number;
  mgid: number;
  mgname: string;
  offerid: number;
  offerlabel: string;
  offerstatus: string;
  prcode: string;
  prlabel: string;
  startdate: string;
  statuslabel: string;
  gpmax: number;
  gpmin: number;
}

export interface ParOfferPricingRequest {
  applicationrule: string;
  assetcategory: string;
  assettype: string;
  catalogid: number;
  enddate: string;
  offerid: number;
  opid: number;
  priid: number;
  pritype: string;
  startdate: string;
}

export interface ParOfferPricingResponse {
  applicationrule: string;
  assetcategory: string;
  assetcategorylabel: string;
  assettype: string;
  assettypelabel: string;
  catalogid: number;
  cataloglabel: string;
  enddate: string;
  offerid: number;
  offerlabel: string;
  offerpricingstatus: string;
  opid: number;
  priid: number;
  prilabel: string;
  pritype: string;
  pritypelabel: string;
  startdate: string;
  statuslabel: string;
}

export function getOfferList(params: GetOfferListParams) {
  return request.get<AbstractResponse<object, ParOfferResponse>>(
    `${URL}/api/offerlist` +
      prepareQueryParams({
        duration: params.duration,
        filters: params.filters,
        finamount: params.finamount,
        prcode: params.prcode,
      } as any)
  );
}

/**
 * @tags Parameters Controller
 * @summary getOfferListByPrcodeAndMgid
 */
export function getOfferListByPrcodeAndMgid(
  params: GetOfferListByPrcodeAndMgidParams
) {
  return request.get<AbstractResponse<object, ParOfferResponse>>(
    `${URL}/api/offerlistByPrcode` +
      prepareQueryParams({
        filters: params.filters,
        prcode: params.prcode,
      } as any)
  );
}

export interface GetOfferListConfigByPrcodeAndMgidParams {
  mgid: number;
  prcode: string;
}

/**
 * @tags Parameters Controller
 * @summary getOfferListConfigByPrcodeAndMgid
 */
export function getOfferListConfigByPrcodeAndMgid(
  params: GetOfferListConfigByPrcodeAndMgidParams
) {
  return request.get<AbstractResponse<object, ParOfferResponse>>(
    `${URL}/api/offerlistConfigByPrcodeAndMgid` +
      prepareQueryParams({ mgid: params.mgid, prcode: params.prcode } as any)
  );
}

export interface GetOfferListByCriteriaParams {
  duration?: number;
  finamount?: number;
  mgid: number;
  offerid?: number;
  offerlabel?: string;
  prcode: string;
  status: string;
}

/**
 * @tags Parameters Controller
 * @summary getOfferListByCriteria
 */
export function getOfferListByCriteria(params: GetOfferListByCriteriaParams) {
  return request.get<AbstractResponse<object, ParOfferListResponse>>(
    `${URL}/api/offers` +
      prepareQueryParams({
        duration: params.duration,
        finamount: params.finamount,
        mgid: params.mgid,
        offerid: params.offerid,
        offerlabel: params.offerlabel,
        prcode: params.prcode,
        status: params.status,
      } as any)
  );
}

export interface CreateOfferParams {
  req: ParOfferResponse;
}

/**
 * @tags Parameters Controller
 * @summary createOffer
 */
export function createOffer(params: CreateOfferParams) {
  return request.post<AbstractResponse<ParOfferResponse, object>>(
    `${URL}/api/offers`,
    params.req
  );
}

export interface UpdateOfferParams {
  req: ParOfferResponse;
}

/**
 * @tags Parameters Controller
 * @summary updateOffer
 */
export function updateOffer(params: UpdateOfferParams) {
  return request.put<AbstractResponse<ParOfferResponse, object>>(
    `${URL}/api/offers`,
    params.req
  );
}

/**
 * @tags Parameters Controller
 * @summary getOfferDetailByOfferId
 */
export function getOfferDetailByOfferId(params: GetOfferDetailByOfferIdParams) {
  return request.get<AbstractResponse<ParOfferResponse, object>>(
    `${URL}/api/offers/${params.offerid}`
  );
}

export interface GetOfferCriteriaParams {
  offerid: number;
}

/**
 * @tags Parameters Controller
 * @summary getOfferCriteria
 */
export function getOfferCriteria(params: GetOfferCriteriaParams) {
  return request.get<AbstractResponse<object, ParOfferCriteriaResponse>>(
    `${URL}/api/offers/${params.offerid}/criteria`
  );
}

export interface AddOfferCriteriaParams {
  req: ParOfferCriteria;
  offerid: number;
}

/**
 * @tags Parameters Controller
 * @summary addOfferCriteria
 */
export function addOfferCriteria(params: AddOfferCriteriaParams) {
  return request.post<AbstractResponse<object, object>>(
    `${URL}/api/offers/${params.offerid}/criteria`,
    params.req
  );
}

export interface RemoveOfferCriteriaParams {
  criid: number;
  offerid: number;
}

/**
 * @tags Parameters Controller
 * @summary removeOfferCriteria
 */
export function removeOfferCriteria(params: RemoveOfferCriteriaParams) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/offers/${params.offerid}/criteria/${params.criid}`
  );
}

export interface DuplicateOfferParams {
  mgid?: number;
  offerid: number;
  prcode?: string;
}

/**
 * @tags Parameters Controller
 * @summary duplicateOffer
 */
export function duplicateOffer(params: DuplicateOfferParams) {
  return request.get<AbstractResponse<ParOfferResponse, object>>(
    `${URL}/api/offers/${params.offerid}/duplicate` +
      prepareQueryParams({ mgid: params.mgid, prcode: params.prcode } as any)
  );
}

export interface GetOfferPricingParams {
  offerid: number;
}

/**
 * @tags Parameters Controller
 * @summary getOfferPricing
 */
export function getOfferPricing(params: GetOfferPricingParams) {
  return request.get<AbstractResponse<object, ParOfferPricingResponse>>(
    `${URL}/api/offers/${params.offerid}/pricing`
  );
}

export interface AddOfferPricingParams {
  req: ParOfferPricingRequest;
  offerid: number;
}

/**
 * @tags Parameters Controller
 * @summary addOfferPricing
 */
export function addOfferPricing(params: AddOfferPricingParams) {
  return request.post<AbstractResponse<object, object>>(
    `${URL}/api/offers/${params.offerid}/pricing`,
    params.req
  );
}

export interface UpdateOfferPricingParams {
  req: ParOfferPricingRequest;
  offerid: number;
}

/**
 * @tags Parameters Controller
 * @summary updateOfferPricing
 */
export function updateOfferPricing(params: UpdateOfferPricingParams) {
  return request.put<AbstractResponse<object, object>>(
    `${URL}/api/offers/${params.offerid}/pricing`,
    params.req
  );
}

export interface RemoveOfferPricingParams {
  offerid: number;
  opid: number;
}

/**
 * @tags Parameters Controller
 * @summary removeOfferPricing
 */
export function removeOfferPricing(params: RemoveOfferPricingParams) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/offers/${params.offerid}/pricing/${params.opid}`
  );
}

export interface UpdateOfferPricingStatusParams {
  offerid: number;
  opid: number;
  status: string;
}

/**
 * @tags Parameters Controller
 * @summary updateOfferPricingStatus
 */
export function updateOfferPricingStatus(
  params: UpdateOfferPricingStatusParams
) {
  return request.put<AbstractResponse<object, object>>(
    `${URL}/api/offers/${params.offerid}/pricing/${params.opid}/updateStatus/${params.status}`
  );
}

export interface UpdateOfferStatusParams {
  offerid: number;
  status: string;
}

/**
 * @tags Parameters Controller
 * @summary updateOfferStatus
 */
export function updateOfferStatus(params: UpdateOfferStatusParams) {
  return request.put<AbstractResponse<ParOfferResponse, object>>(
    `${URL}/api/offers/${params.offerid}/updateStatus/${params.status}`
  );
}

export interface ParOfferPricingAttributeCriteriaResponse {
  applicationrule: string;
  attid: number;
  criid: number;
  critcode: string;
  critcodelabel: string;
  critoperand: string;
  critvalue: string;
  critvaluelabel: string;
  critvaluemax: string;
  listvalue: string;
}

export interface ParOfferPricingAttribute {
  attamountdefault: number;
  attamountmax: number;
  attamountmethod: string;
  attamountmin: number;
  attcode: string;
  attcoefdefault: number;
  attcoefmax: number;
  attcoefmin: number;
  attdirection: string;
  attexternalreference: string;
  attid: number;
  attmethod: string;
  attnbdays: number;
  attrate: number;
  atttype: string;
  flagaddmanual: boolean;
  flagdelete: boolean;
  flagupdate: boolean;
  offerid: number;
  priid: number;
  proccode: string;
  requestreceiverid: number;
  requestreceiverroleprofile: string;
  requestreceivertype: string;
  requesttype: string;
  taskid: number;
  tpid: number;
  tprole: string;
  nbmonthsmax: number;
  flagaddauto: boolean;
  startdate: string;
  enddate: string;
  status: string;
  attamountrequested: number;
  attamountagreed: number;
  nbmonthsrequested: number;
}

export interface ParOfferPricingAttributeCriteria {
  applicationrule: string;
  attid: number;
  criid: number;
  critcode: string;
  critoperand: string;
  critvalue: string;
  critvaluemax: string;
  listvalue: string;
}

export interface AddOfferPricingAttributeParams {
  req: ParOfferPricingAttribute;
}

/**
 * @tags Pricing Controller
 * @summary addOfferPricingAttribute
 */
export function addOfferPricingAttribute(
  params: AddOfferPricingAttributeParams
) {
  return request.post<AbstractResponse<object, object>>(
    `${URL}/api/pricingAttribute`,
    params.req
  );
}

export interface UpdateOfferPricingAttributeParams {
  req: ParOfferPricingAttribute;
}

/**
 * @tags Pricing Controller
 * @summary updateOfferPricingAttribute
 */
export function updateOfferPricingAttribute(
  params: UpdateOfferPricingAttributeParams
) {
  return request.put<AbstractResponse<object, object>>(
    `${URL}/api/pricingAttribute`,
    params.req
  );
}

export interface RemoveOfferPricingAttributeParams {
  attid: number;
}

/**
 * @tags Pricing Controller
 * @summary removeOfferPricingAttribute
 */
export function removeOfferPricingAttribute(
  params: RemoveOfferPricingAttributeParams
) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/pricingAttribute/${params.attid}`
  );
}

export interface GetOfferPricingAttributeListParams {
  objectid: number;
  objecttype: string;
}

/**
 * @tags Pricing Controller
 * @summary getOfferPricingAttributeList
 */
export function getOfferPricingAttributeList(
  params: GetOfferPricingAttributeListParams
) {
  return request.get<
    AbstractResponse<object, ParOfferPricingAttributeResponse>
  >(`${URL}/api/pricingAttribute/${params.objecttype}/${params.objectid}`);
}

export interface GetOfferPricingAttributeDetailParams {
  attid: number;
}

/**
 * @tags Pricing Controller
 * @summary getOfferPricingAttributeList
 */
export function getOfferPricingAttributeDetail(
  params: GetOfferPricingAttributeDetailParams
) {
  return request.get<
    AbstractResponse<ParOfferPricingAttributeResponse, object>
  >(`${URL}/api/pricingAttributeDetail/${params.attid}`);
}

export interface AddOfferPricingAttributeCriteriaParams {
  req: ParOfferPricingAttributeCriteria;
}

/**
 * @tags Pricing Controller
 * @summary addOfferPricingAttributeCriteria
 */
export function addOfferPricingAttributeCriteria(
  params: AddOfferPricingAttributeCriteriaParams
) {
  return request.post<AbstractResponse<object, object>>(
    `${URL}/api/pricingAttributeCriteria`,
    params.req
  );
}

export interface GetOfferPricingAttributeCriteriaListParams {
  attid: number;
}

/**
 * @tags Pricing Controller
 * @summary getOfferPricingAttributeCriteriaList
 */
export function getOfferPricingAttributeCriteriaList(
  params: GetOfferPricingAttributeCriteriaListParams
) {
  return request.get<
    AbstractResponse<object, ParOfferPricingAttributeCriteriaResponse>
  >(`${URL}/api/pricingAttributeCriteria/${params.attid}`);
}

export interface RemoveOfferPricingAttributeCriteriaParams {
  criid: number;
}

/**
 * @tags Pricing Controller
 * @summary removeOfferPricingAttributeCriteria
 */
export function removeOfferPricingAttributeCriteria(
  params: RemoveOfferPricingAttributeCriteriaParams
) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/pricingAttributeCriteria/${params.criid}`
  );
}

export interface GetParPricingLabelParams {
  priid: number;
}

export interface GetApplicableOfferPricingAttributeListParams {
  filters: prFilteringCriteria;
  objectid: number;
  objecttype: string;
}

/**
 * @tags Pricing Controller
 * @summary getApplicableOfferPricingAttributeList
 */
export function getApplicableOfferPricingAttributeList(
  params: GetApplicableOfferPricingAttributeListParams
) {
  return request.post<
    AbstractResponse<object, ParOfferPricingAttributeResponse>
  >(
    `${URL}/api/pricingAttributeApplicable/${params.objecttype}/${params.objectid}`,
    params.filters
  );
}

export interface GetParAssetUseConditionDetailByUsedidParams {
  useid: number;
  usevalue: number;
}

/**
 * @tags Par Asset Use Controller
 * @summary getParAssetUseConditionDetailByUsedid
 */
export function getParAssetUseConditionDetailByUsedid(
  params: GetParAssetUseConditionDetailByUsedidParams
) {
  return request.get<AbstractResponse<ParAssetUseConditionResponse, object>>(
    `${URL}/api/config/parassetusecondition/byValue` +
      prepareQueryParams({
        useid: params.useid,
        usevalue: params.usevalue,
      } as any)
  );
}

export interface RemovePrefinStepParams {
  ctesid: number;
}

/**
 * @tags Par Offer Controller
 * @summary removePrefinStep
 */
export function removePrefinStep(params: RemovePrefinStepParams) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/offerprefinstep/${params.ctesid}`
  );
}

export interface GetOfferPrefinStepByOfferidParams {
  offerid: number;
}

export interface ParOfferPrefinStep {
  calmethod: string;
  ctesamortizedamount: number;
  ctesamortizedcoef: number;
  ctesduration: number;
  ctesid: number;
  ctesorder: number;
  ctesoutstandingamount: number;
  ctesoutstandingcoef: number;
  ctesperiodicity: string;
  ctesperiodicityunit: string;
  nominalrate: number;
  offerid: number;
  ratebasis: string;
  rateformula: string;
  ratespread: number;
}

export interface ParOfferPrefinStepRequest {
  calmethod: string;
  ctesamortizedamount: number;
  ctesamortizedcoef: number;
  ctesduration: number;
  ctesid: number;
  ctesorder: number;
  ctesoutstandingamount: number;
  ctesoutstandingcoef: number;
  ctesperiodicity: string;
  ctesperiodicityunit: string;
  nominalrate: number;
  offerid: number;
  ratebasis: string;
  rateformula: string;
  ratespread: number;
}

export interface ParOfferPrefinStepResponse {
  calmethod: string;
  ctesamortizedamount: number;
  ctesamortizedcoef: number;
  ctesduration: number;
  ctesid: number;
  ctesorder: number;
  ctesoutstandingamount: number;
  ctesoutstandingcoef: number;
  ctesperiodicity: string;
  ctesperiodicityunit: string;
  nominalrate: number;
  offerid: number;
  ratebasis: string;
  rateformula: string;
  ratespread: number;
}

/**
 * @tags Par Offer Controller
 * @summary getOfferPrefinStepByOfferid
 */
export function getOfferPrefinStepByOfferid(
  params: GetOfferPrefinStepByOfferidParams
) {
  return request.get<AbstractResponse<object, ParOfferPrefinStepResponse>>(
    `${URL}/api/offerprefinstep/${params.offerid}`
  );
}

export interface AddPrefinStepParams {
  request: ParOfferPrefinStepRequest;
}

/**
 * @tags Par Offer Controller
 * @summary addPrefinStep
 */
export function addPrefinStep(params: AddPrefinStepParams) {
  return request.post<AbstractResponse<object, object>>(
    `${URL}/api/offerprefinstep`,
    params.request
  );
}
